<template>
  <div class="dashboard-layout">
    <sidebar-nav />
    <main class="main-content">
      <header class="page-header">
        <div class="title-wrap">
          <router-link v-if="backTo" :to="backTo" class="back-link">
            <nav-icon name="chevronLeft" :size="15" /> {{ backLabel }}
          </router-link>
          <h1>{{ title }}</h1>
          <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
        </div>
        <div v-if="$slots.actions" class="actions"><slot name="actions" /></div>
      </header>
      <div class="page-body">
        <slot />
      </div>
    </main>
  </div>
</template>

<script>
import SidebarNav from '../SidebarNav.vue'
import NavIcon from '../NavIcon.vue'

export default {
  name: 'DashboardLayout',
  components: { SidebarNav, NavIcon },
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    backTo: { type: String, default: '' },
    backLabel: { type: String, default: 'Back' }
  }
}
</script>

<style scoped>
.dashboard-layout { display: flex; height: 100vh; }
.main-content {
  flex-grow: 1;
  min-width: 0;
  padding: 20px 22px 28px;
  overflow-y: auto;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}
.title-wrap { min-width: 0; }
.back-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-bottom: 6px;
  font-size: 12.5px;
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.2s ease;
}
.back-link:hover { color: var(--primary-color); }
.page-header h1 {
  font-size: 23px;
  line-height: 1.15;
  margin: 0;
  font-weight: 700;
  color: var(--text-primary);
}
.subtitle { margin: 4px 0 0; font-size: 13px; color: var(--text-secondary); }
.actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.page-body { display: flex; flex-direction: column; gap: 16px; }

@media (max-width: 1024px) {
  .main-content { padding: 16px 16px 24px; padding-top: 64px; }
  .page-header { align-items: stretch; }
  .actions { width: 100%; }
}
</style>
